import React, { type ForwardedRef, forwardRef } from 'react';

import { type TextAreaProps } from './TextArea.types';

import { PrimitiveTextArea } from './TextArea.style';

function TextAreaComponent(
    {
        value = '',
        disabled = false,
        error = false,
        readOnly = false,
        ariaLabel,
        onBlur,
        onFocus,
        onChange,
        ...rest
    }: TextAreaProps,
    ref: ForwardedRef<HTMLTextAreaElement>,
) {
    const noInteraction = Boolean(disabled || readOnly);

    // Some attributes, such as `autoComplete` and `data-1p-ignore`
    // are specifically added to prevent browser extension injected UI.
    return (
        <PrimitiveTextArea
            ref={ref}
            {...rest}
            data-1p-ignore
            data-input-error={error ? true : undefined}
            rows={1}
            autoComplete="off"
            spellCheck="false"
            value={value ?? ''}
            aria-label={ariaLabel}
            disabled={Boolean(disabled || !onChange)}
            readOnly={Boolean(readOnly || !onChange)}
            onBlur={noInteraction ? undefined : onBlur}
            onFocus={noInteraction ? undefined : onFocus}
            onChange={noInteraction ? undefined : onChange}
        />
    );
}

export const TextArea = forwardRef(TextAreaComponent);
